<template>
  <section class="h-dvh">
    <UContainer class="py-8 h-full">
      <div class="h-full  flex items-center justify-center">
        <div class="w-100 p-4 bg-white border border-gray-200 rounded-2xl shadow-lg max-w-md
                    dark:bg-gray-800 dark:border-gray-700">
          <!-- Zone logo avec hauteur fixe, pas de reflow -->
          <div class="relative h-15 md:h-20 mb-8">
            <!-- Img 1 -->
            <img :src="images[0]" alt="Frederique Constant" class="fade-img absolute inset-0 m-auto max-h-full object-contain
                     transition-opacity duration-900 ease-in-out" :class="showFirstImage ? 'opacity-100' : 'opacity-0'"
              decoding="async" loading="eager" />
            <!-- Img 2 -->
            <img :src="images[1]" alt="Alpina" class="fade-img absolute inset-0 m-auto max-h-full object-contain
                     transition-opacity duration-900 ease-in-out" :class="showFirstImage ? 'opacity-0' : 'opacity-100'"
              decoding="async" loading="lazy" />
          </div>

          <Login />
        </div>
      </div>
    </UContainer>
  </section>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'

const showFirstImage = ref(true)
const images = [
  '/logo/frederique_constant.svg',
  '/logo/Corporate_ALPINA_Logo_V.svg'
]

let intervalId
onMounted(() => {
  // alterne sans reflow
  intervalId = setInterval(() => {
    showFirstImage.value = !showFirstImage.value
  }, 1800) // 1.5s = élégant; mets 500 si tu veux clignoter vite
})
onUnmounted(() => clearInterval(intervalId))
</script>

<style scoped>
/* Accessibilité : si l’utilisateur préfère moins d’animations */
@media (prefers-reduced-motion: reduce) {
  .fade-img {
    transition: none !important;
  }
}
</style>